var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProcessed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Processed_Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Processed_Icon",
    "data-name": "Processed Icon",
    clipPath: "url(#clip-Processed_Icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36032",
    "data-name": "Group 36032",
    transform: "translate(-9432.75 -14170.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36032-2",
    "data-name": "Group 36032",
    transform: "translate(9433.5 14171)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16934",
    "data-name": "Rectangle 16934",
    width: 10.5,
    height: 10.5,
    rx: 4,
    fill: "rgba(0,154,23,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16934_-_Outline",
    "data-name": "Rectangle 16934 - Outline",
    d: "M2.625.656A1.971,1.971,0,0,0,.656,2.625v5.25A1.971,1.971,0,0,0,2.625,9.844h5.25A1.971,1.971,0,0,0,9.844,7.875V2.625A1.971,1.971,0,0,0,7.875.656H2.625m0-.656h5.25A2.625,2.625,0,0,1,10.5,2.625v5.25A2.625,2.625,0,0,1,7.875,10.5H2.625A2.625,2.625,0,0,1,0,7.875V2.625A2.625,2.625,0,0,1,2.625,0Z",
    fill: "#009a17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38859",
    "data-name": "Path 38859",
    d: "M104.616,122.152a.431.431,0,0,1-.132.31l-1.978,2.178c-.211.232-.421.466-.634.7a.409.409,0,0,1-.661.009q-.7-.7-1.39-1.412a.4.4,0,0,1,.293-.706.444.444,0,0,1,.293.148c.345.351.691.7,1.033,1.054.066.068.1.073.167,0q1.121-1.243,2.248-2.481a.463.463,0,0,1,.373-.191.4.4,0,0,1,.387.4Z",
    transform: "translate(-96.901 -118.382)",
    fill: "#009a17"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcessed);
export default __webpack_public_path__ + "static/media/Icon_Processed.8040b7fac875baa088883bed699ad681.svg";
export { ForwardRef as ReactComponent };